<mbs-loader *ngIf="loading"></mbs-loader>

<ng-container *ngIf="!loading">
  <div class="mb-3 bg-secondary border rounded">
    <div class="m-3 row">
      <div class="col-12">
        <form [formGroup]="profileSettings">
          <mbs-input formControlName="name"
                     [boldLabel]="true"
                     [label]="'mbs-ui:rmm-custom-alerting.newProfileName' | i18next"
                     [disabledSelf]="false">
          </mbs-input>
        </form>
      </div>
    </div>

    <div class="m-0 my-1 row">
      <hr class="col bg-grey-100">
    </div>

    <div class="mx-3 row">
      <div class="mb-2 col-12">
        <mbs-alert *ngIf="intersectionError"
                   [icon]="true"
                   [type]="'warning'">
          <ng-container *ngIf="modeSelectionForm.get('modeSelect').value === modeItems[0].id; else selectComputersUseCase">
            {{ 'mbs-ui:rmm-custom-alerting.errorIntersectionGlobal' | i18next }}

            <mbs-button [isCtrl]="true"
                        size="sm"
                        (click)="openGlobalProfileOnSeparatePage()">
              {{ 'mbs-ui:rmm-custom-alerting.errorIntersectionGlobalBtn' | i18next }}
            </mbs-button>
          </ng-container>

          <ng-template #selectComputersUseCase>
            <div *ngIf="modeSelectionForm.get('modeSelect').value === modeItems[1].id">
              {{ 'mbs-ui:rmm-custom-alerting.errorIntersectionCompany' | i18next }}
            </div>
            <div *ngIf="modeSelectionForm.get('modeSelect').value === modeItems[2].id">
              {{ 'mbs-ui:rmm-custom-alerting.errorIntersectionComputer' | i18next }}
            </div>
          </ng-template>


        </mbs-alert>

        <div *ngIf="intersectionData?.length">
          <mbs-alert [icon]="true"
                     [type]="'warning'">
            <div>{{ 'mbs-ui:rmm-custom-alerting.foundIntersection' | i18next }}</div>
            <mbs-button [isCtrl]="true"
                        [size]="'sm'"
                        (click)="openIntersectionModalStream()">
              {{ 'mbs-ui:rmm-custom-alerting.showIntersection' | i18next }}
            </mbs-button>
          </mbs-alert>
        </div>

        <form [formGroup]="modeSelectionForm">
          <mbs-input-label [boldLabel]="true"
                           [label]="'shared:rmm.groupActions.stepApplyTo.title' | i18next">
          </mbs-input-label>
          <mbs-select [items]="modeItems"
                      [bindLabel]="'value'"
                      [bindValue]="'id'"
                      [clearable]="false"
                      [searchable]="false"
                      formControlName="modeSelect"
                      [disabledSelf]="disableChanges">
          </mbs-select>
        </form>
      </div>

      <div *ngIf="modeSelectionForm.get('modeSelect').value === selectOptions.ApplyToAllComputersInSelectedCompanies"
           class="col-12">
        <mbs-iteration-ctrl-button (buttonClick)="openSelectCompaniesModal()"
                                   [editIconVisible]="true"
                                   [selected]="selectedCompanyList"
                                   [emptyLabel]="'shared:rmm.groupActions.stepApplyTo.selectCompanies' | i18next">
        </mbs-iteration-ctrl-button>
      </div>
      <div *ngIf="modeSelectionForm.get('modeSelect').value === selectOptions.ApplyToSelectedComputersOnly"
           class="col-12 mb-3">
        <mbs-iteration-ctrl-button (buttonClick)="openSelectComputersModal()"
                                   [editIconVisible]="true"
                                   [selected]="selectedComputerList"
                                   [emptyLabel]="'shared:rmm.groupActions.stepApplyTo.selectComputers' | i18next">
        </mbs-iteration-ctrl-button>
      </div>
    </div>


    <div *ngIf="modeSelectionForm.get('modeSelect').value !== null && modeSelectionForm.get('modeSelect').value !== selectOptions.ApplyToSelectedComputersOnly"
         class="m-0 my-1 row">
      <hr class="col bg-grey-100">
    </div>

    <div *ngIf="modeSelectionForm.get('modeSelect').value !== null && modeSelectionForm.get('modeSelect').value !== selectOptions.ApplyToSelectedComputersOnly"
         class="mx-3 mb-3 row">
      <div class="col-12">
        <form [formGroup]="modeSelectionForm">
          <div class="row">
            <div class="col">
              <mbs-input-label class="mbs-form_label mb-0"
                               [boldLabel]="true"
                               [label]="'shared:rmm.groupActions.stepApplyTo.selectTagDescription' | i18next"
                               for="enabled">
              </mbs-input-label>

              <div class="text-sm">
                {{ 'mbs-ui:rmm-custom-alerting.wizard.firstStep.tagLogicDescription' | i18next }}
              </div>

              <div class="row">
                <div class="col-10">
                  <div *ngIf="selectedTagNames.length"
                       class="mt-1">
                    <span *ngFor="let tag of selectedTagNames"
                          class="mr-2">
                      <mbs-tag class="my-1"
                               [clickable]="false"
                               [closable]="true"
                               [active]="false"
                               [noBorder]="false"
                               [class.bg-danger-20]="tag?.removed"
                               (mbsClose)="handleClose(tag)">
                        {{ tag?.name ?? 'shared:rmm-group-task.removedTagName' | i18next: { value: tag.id } }}
                      </mbs-tag>
                    </span>
                  </div>
                  <div class="mt-2">
                    <mbs-button [isCtrl]="true"
                                [size]="'md'"
                                (click)="openSelectTagsModal()"
                                [disabled]="disableTagAndExclude">
                      {{ 'shared:rmm.groupActions.stepApplyTo.selectTags' | i18next }}
                    </mbs-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-auto">
              <mbs-switcher formControlName="enableTags"
                            [disabledSelf]="disableTagAndExclude">
              </mbs-switcher>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>


  <form *ngIf="modeSelectionForm.get('modeSelect').value !== null && modeSelectionForm.get('modeSelect').value !== selectOptions.ApplyToSelectedComputersOnly"
        class="mb-3 bg-secondary border rounded"
        [formGroup]="modeSelectionForm">
    <div class="m-3 row">
      <div class="col">
        <mbs-input-label class="mbs-form_label mb-0"
                         [boldLabel]="true"
                         [label]="'shared:rmm.groupActions.stepApplyTo.excludeComputers' | i18next"
                         for="enabled">
        </mbs-input-label>
        <div class="text-sm">{{ 'shared:rmm.groupActions.stepApplyTo.excludeComputersDescription' | i18next }}</div>
        <div class="row mt-1">
          <div class="col-10">
            <mbs-iteration-ctrl-button (buttonClick)="openSelectComputersModal(true)"
                                       [selected]="selectedExcludedComputersList"
                                       [disabled]="disableTagAndExclude"
                                       [emptyLabel]="'shared:rmm.groupActions.stepApplyTo.selectComputers' | i18next">
            </mbs-iteration-ctrl-button>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <mbs-switcher formControlName="enableExclude"
                      [disabledSelf]="disableTagAndExclude">
        </mbs-switcher>
      </div>
    </div>
  </form>
</ng-container>

<ng-template #tagSelectionModal>
  <mbs-list-select [data]="tags"
                   bindSelected="id"
                   [showSearch]="true"
                   [showCheckboxes]="true"
                   [showTopControls]="true"
                   [topControlsLabelSelected]="false"
                   [selectedData]="selectedTagList"
                   (changeSelected)="changeTagsHandler($event)"
                   [keepState]="true"
                   [loadSource]="false"
                   filterFields="name"
                   placeholder="Enter search request"
                   [selectRowClass]="'-selected'"
                   [headers]="tagHeaders">

    <ng-template prependTopControlsLabel>
      <strong>{{ 'shared:buttons.selectAll' | i18next }}</strong>
    </ng-template>

    <ng-template let-tag
                 mbsTableCell>
      {{ tag.name }}
    </ng-template>
  </mbs-list-select>
</ng-template>


<ng-template #intesectionModalContent>
  {{ 'mbs-ui:rmm-custom-alerting.intersectionWizardInfo1' | i18next}}
  <ul>
    <li>{{ 'mbs-ui:rmm-custom-alerting.intersectionWizardInfo2' | i18next}}</li>
    <li>{{ 'mbs-ui:rmm-custom-alerting.intersectionWizardInfo3' | i18next}}</li>
    <li>{{ 'mbs-ui:rmm-custom-alerting.intersectionWizardInfo4' | i18next}}</li>
    <li>{{ 'mbs-ui:rmm-custom-alerting.intersectionWizardInfo5' | i18next}}</li>
  </ul>

  <mbs-table-grid [loading]="false"
                  [headers]="intersectionHeaders"
                  [data]="intersectionData ?? []"
                  [showRefreshButton]="false"
                  [stripedTable]="false"
                  [maxHeight]="'50vh'"
                  [noDataMessage]="'shared:rmm.groupActions.noTableDataMessage' | i18next: { format: 'capitalize' }">

    <ng-template mbsTableCell
                 let-item>
      <mbs-text-ellipsis placement="top-left"
                         container="body"
                         tooltipClass="tooltip-lg"
                         [tooltip]="item.computerName">
        {{ item.name }}
      </mbs-text-ellipsis>
    </ng-template>

    <ng-template mbsTableCell
                 let-item>
      <span [class]="item.priority ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'">
      </span>
      <span class="fw-semibold">
        {{ ('mbs-ui:rmm-custom-alerting.priority.' + (item.priority ? 'noEffect' : 'affected')) | i18next }}
      </span>
      <span>
        {{ ('mbs-ui:rmm-custom-alerting.priority.' + (item.priority ? 'high' : 'low')) | i18next }}
      </span>
    </ng-template>

  </mbs-table-grid>
</ng-template>
